import { AfterViewInit, Component, Inject } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ParametroParceiroService } from "src/app/services/parametro-parceiro.service";
import { ParametrosEspecificosConstants } from "src/app/models/constants/constants";
import { Misc } from "src/app/components/util/misc";

@Component({
  selector: "app-modal-aba-parceiro",
  templateUrl: "./modal-aba-parceiro.component.html",
  styleUrls: ["./modal-aba-parceiro.component.scss"],
})
export class ModalAbaParceiroComponent implements AfterViewInit {
  public readonly titulo = "Parâmetros de Parceiros";
  public basicFormModal: UntypedFormGroup;
  public parametroParceiroSelected: object;
  public estimativaSelected: Object;

  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private getParametroParceiro: ParametroParceiroService,
    public misc: Misc
  ) {
    this.loadFormModal();
  }
  ngAfterViewInit() {
    this.loadParametros();
  }

  private loadFormModal() {
    this.basicFormModal = this.fb.group({
      administrativo: [null],
      comissao: [null],
      impostos: [null],
      investimento: [null],
      margemLiquida: [null],
    });
  }

  private loadParametros() {
    if (this.data) {
      this.parametroParceiroSelected = this.getParametroParceiro
        .getParametroParceiros(this.data)
        .subscribe(
          (res: any) => {
            let estimativas = res.items;

            this.basicFormModal.patchValue({
              administrativo: estimativas.find(
                (p: any) =>
                  p.id ==
                    ParametrosEspecificosConstants.ID_PC_ADMINISTRATIVOPARC ||
                  p.priceParamId ==
                    ParametrosEspecificosConstants.ID_PC_ADMINISTRATIVOPARC
              ).valor,

              comissao: estimativas.find(
                (p: any) =>
                  p.id == ParametrosEspecificosConstants.ID_PC_COMISSAOPARC ||
                  p.priceParamId ==
                    ParametrosEspecificosConstants.ID_PC_COMISSAOPARC
              ).valor,

              impostos: estimativas.find(
                (p: any) =>
                  p.id == ParametrosEspecificosConstants.ID_PC_IMPOSTOPARC ||
                  p.priceParamId ==
                    ParametrosEspecificosConstants.ID_PC_IMPOSTOPARC
              ).valor,

              investimento: estimativas.find(
                (p: any) =>
                  p.id ==
                    ParametrosEspecificosConstants.ID_PC_INVESTIMENTOPARC ||
                  p.priceParamId ==
                    ParametrosEspecificosConstants.ID_PC_INVESTIMENTOPARC
              ).valor,

              margemLiquida: estimativas.find(
                (p: any) =>
                  p.id ==
                    ParametrosEspecificosConstants.ID_PC_MARGEMLIQUIDAPARC ||
                  p.priceParamId ==
                    ParametrosEspecificosConstants.ID_PC_MARGEMLIQUIDAPARC
              ).valor,
            });
          },
          (error) => {
            this.misc.processError("Tivemos um erro ao Buscar os Parametros");
          }
        );
    } else {
      this.misc.processError("Selecione um Parceiro para os cálculos");
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  public save() {
    this.estimativaSelected = {
      administrativo: this.basicFormModal.get("administrativo").value,
      comissao: this.basicFormModal.get("comissao").value,
      impostos: this.basicFormModal.get("impostos").value,
      investimento: this.basicFormModal.get("investimento").value,
      margemLiquida: this.basicFormModal.get("margemLiquida").value,
    };
    this.getParametroParceiro.emitSalvarEstimativa(this.estimativaSelected);
    this.dialogRef.close();
  }
}
